function addStyle(win, css) {
  let head = win.document.head || win.document.getElementsByTagName("head")[0],
    style = document.createElement("style");

  head.appendChild(style);

  style.type = "text/css";

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(win.document.createTextNode(css));
  }
}

const VuePrintPlugin = {
  install(Vue, options = {}) {
    Vue.prototype.$PrintPlugin = (el, css, title) => {
      let name = "_blank",
        specs = ["titlebar=yes", "fullscreen=yes", "scrollbars=yes"].join(","),
        replace = true;

      // specs = specs.length > 0 ? specs.join(',') : '';

      const element = window.document.getElementById(el);

      if (!element) {
        return;
      }

      const url = "";
      const print_window = window.open(url, name, specs, replace);

      if (!print_window) {
        return false;
      }

      print_window.document.write(`
        <html>
          <head>
            <title>${title || window.document.title}</title>
          </head>
          <body>
            ${element.innerHTML}
          </body>
        </html>
      `);

      if (css) {
        addStyle(print_window, css);
      }

      print_window.document.close();

      const imagesLoaded = Array.from(print_window.document.images).map(image => {
        if (image.complete) {
          return Promise.resolve();
        }

        return new Promise(resolve => {
          image.addEventListener("load", resolve, { once: true });
          image.addEventListener("error", resolve, { once: true });
        });
      });

      Promise.all(imagesLoaded).then(() => {
        setTimeout(() => {
          if (!print_window.closed) {
            print_window.focus();
            print_window.print();
          }
        }, 500);
      });

      return true;
    };
  },
};

export default VuePrintPlugin;
